import React, { useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import MenuIcon from '@mui/icons-material/Menu';
import '../Styles/topbar.css';
import { replace, useNavigate } from 'react-router-dom';
import uiColors from '../Styles/uiColors';



const Topbar = ({ mobileOpen, setMobileOpen }) => {
  const { user, logout, loading } = useContext(AuthContext);
  const drawerWidth = 240;
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        borderBottom: uiColors.background,
        paddingX: { xs: 1.5, md: 4 },
        zIndex: theme.zIndex.drawer + 1,
        left: { md: `${drawerWidth}px`, xs: 0 },
        width: { md: `calc(100% - ${drawerWidth}px)`, xs: '100%' },
      }}
      className="topbar"
    >
      <Toolbar
        className="topbar"
        sx={{
          minHeight: { xs: 56, sm: 64 },
          gap: 1,
        }}
      >
        {/* Hamburger (mobile only) */}
        <IconButton
          color="inherit"
          edge="start"
          sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          onClick={() => setMobileOpen(prev => !prev)}
        >
          <MenuIcon />
        </IconButton>

        <Typography
          className="topbar-title"
          sx={{
            fontSize: isMobile ? '1rem' : '1.25rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          Central Kitchen Dashboard
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Box className="topbar-right">
          {!isMobile && (
            <Typography className="topbar-greeting">
              {loading
                ? 'Loading...'
                : `Hello, ${user?.fullName || user?.role || 'Guest'}!`}
            </Typography>
          )}

          <button
            className="topbar-home"
            onClick={() => navigate('/', { replace: true })}
          >
            Home
          </button>

          <button
            className="topbar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
